import axios from 'axios'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { config } from '../../function/config'
import ManagerHeader from './ManagerHeader'

export default function AddBeds() {
    const navigate = useNavigate()
    const token = localStorage.getItem('token')
    const [loading, setLoading] = useState(false)

    const [formData, setFormData] = useState({
        bed_no:'',
        bed_type:'',
        description:'',
    })

    const [errors, setErrors] = useState({
        bed_no:'',
        bed_type:'',
        description:'',
    })
    
    const handleChange = (e) => {
        const { name, value } = e.target

        setFormData((prev) => ({
            ...prev,
            [name]:value
        }))

        setErrors((prev) => ({
            ...prev,
            [name]:''
        }))
    }

    const validateForm = (data) => {
        const newErrors = {}

        if(!String(data.bed_no || '').trim()){
            newErrors.bed_no = 'Bed Number is required'
        }

        if(!data.bed_type.trim() || ''){
            newErrors.type = 'Please select Type'
        }

        if(!data.description.trim() || ''){
            newErrors.description = 'Description is required'
        }

        return newErrors
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        const validationErrors = validateForm(formData)

        setErrors(validationErrors)

        if (Object.keys(validationErrors).length > 0) {
            const firstError = Object.values(validationErrors)[0]
            toast.error(firstError)
            return
        }

        try {
            setLoading(true)

            const payload = {
                bed_no: String(formData.bed_no || '').trim(),
                bed_type: String(formData.bed_type || '').trim(),
                description: String(formData.description || '').trim()
            }
            console.log('Sending Bed Data:', payload)

            const res = await axios.post(`${config.baseurl}create_beds/`, payload,{
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${token}`
                }
            })
            console.log('Create Bed Response:', res.data)

            if (res.status === 200 || res.status === 201) {
                toast.success(res.data?.message || 'Beds Created Successfully')

                setFormData({
                    bed_no: '',
                    bed_type: '',
                    description: ''
                })

                setErrors({
                    bed_no: '',
                    bed_type: '',
                    description: ''
                })

                setTimeout(() => {
                    navigate(-1)
                }, 300)

            } else {
                toast.error(res.data?.message || 'Failed to create bed')
            }
        } catch (error) {
            console.error('Create Bed Error:', error.response?.data || error)

            const errorData = error.response?.data

            // Backend: { message: {...} }
            if (errorData?.message && typeof errorData.message === 'object') {
                Object.entries(errorData.message).forEach(
                    ([field, messages]) => {
                        if (Array.isArray(messages)) {
                            messages.forEach((msg) => {
                                toast.error(msg, {
                                    autoClose: 10000
                                })
                            })
                        } else {
                            toast.error(String(messages), {
                                autoClose: 10000
                            })
                        }

                    }
                )

            }

            // Backend: { message: "..." }
            else if (errorData?.message) {
                toast.error(
                    String(errorData.message),
                    {
                        autoClose: 10000
                    }
                )
            }

            // Backend: { error: "..." }
            else if (errorData?.error) {
                toast.error(
                    String(errorData.error),
                    {
                        autoClose: 10000
                    }
                )
            }

            // Backend: { detail: "..." }
            else if (errorData?.detail) {
                toast.error(
                    String(errorData.detail),
                    {
                        autoClose: 10000
                    }
                )
            }

            // Axios/network error
            else if (error.message) {
                toast.error(
                    error.message,
                    {
                        autoClose: 10000
                    }
                )
            }

            else {
                toast.error(
                    'Failed to create bed',
                    {
                        autoClose: 10000
                    }
                )
            }
        } finally {
            setLoading(false)
        }
    }

    const inputClass ='w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-sm text-slate-800 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100 placeholder:text-slate-400'

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 ml-64 5xl:ml-0">
        <ManagerHeader/>

        {/* HEADER */}
        <div className="max-w-7xl mx-auto px-6 pt-16 pb-6">
            <div className="items-center justify-between text-center">
                <h1 className="mt-1 text-3xl font-bold text-slate-800">
                    ADD Beds
                </h1>

                <p className="mt-2 text-sm text-slate-500">
                    Create a new Beds.
                </p>
            </div>
        </div>

        {/* FORM SECTION */}
        <div className="max-w-7xl mx-auto px-6 pb-12">            
            <div className="mx-auto max-w-5xl overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-lg">

                {/* Form */}
                <form onSubmit={handleSubmit} className="p-6 md:p-8">
                    <div className="grid grid-cols-1 gap-6 md:grid-cols-2">

                        {/* Bed Number */}
                        <div className="md:col-span-2">
                            <label
                                htmlFor="bed_no"
                                className="mb-2 block text-sm font-semibold text-slate-700"
                            >
                                Bed Number
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <input
                                id="bed_no"
                                type="text"
                                name="bed_no"
                                placeholder="Enter Bed Number"
                                value={formData.bed_no}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.bed_no
                                    ? 'border-red-500 focus:border-red-600'
                                    : ''
                                }`}
                            />

                            {errors.bed_no && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.bed_no}</p>
                            )}
                        </div>

                        {/* Type */}
                        <div className="md:col-span-2">
                            <label
                                htmlFor="Bed Type"
                                className="mb-2 block text-sm font-semibold text-slate-700"
                            >
                                Bed Type
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <select
                                id="bed_type"
                                name="bed_type"
                                value={formData.bed_type}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.bed_type
                                    ? 'border-red-500 focus:border-red-600'
                                    : ''
                                }`}
                            >
                                <option value="">Select Type</option>
                                <option value="Child">Child</option>
                                <option value="Aged Person">Aged Person</option>
                            </select>

                            {errors.bed_type && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.bed_type}</p>
                            )}
                        </div>

                        {/* Description */}
                        <div className="md:col-span-2">
                            <label
                                htmlFor="description"
                                className="mb-2 block text-sm font-semibold text-slate-700"
                            >
                                Description
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <textarea
                                id="description"
                                name="description"
                                rows={4}
                                placeholder="Enter complete branch description"
                                value={formData.description}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.description
                                    ? 'border-red-500 focus:border-red-600'
                                    : ''
                                }`}
                            />

                            {errors.description && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.description}</p>
                            )}
                        </div>
                    </div>

                    {/* Form Actions */}
                    <div className="mt-8 flex flex-row gap-3 border-t border-slate-200 pt-6 2xl:flex-col-reverse justify-end">
                        <button
                            type="button"
                            onClick={() => navigate(-1)}
                            disabled={loading}
                            className="rounded-xl bg-slate-100 px-6 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-200 disabled:cursor-not-allowed disabled:opacity-50"
                        >
                            Cancel
                        </button>

                        <button
                            type="submit"
                            disabled={loading}
                            className="rounded-xl bg-[#000435] px-7 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-[#000326] disabled:cursor-not-allowed disabled:opacity-50"
                        >
                            {loading ? 'Submitting...' : 'Submit'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
  )
}
